import cloneDeep from 'lodash/cloneDeep';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { FormattedHTMLMessage } from 'react-intl';
import SetCashDecision from '../../mutations/SetCashDecision';
import { MultiYearScalarType } from '../../types';
import EconomicChart from '../EconomicChart';
import Icon from '../Icon';
import ResultsDocumentLayout from '../ResultsDocumentLayout';
import TextArea from '../TextArea';
import gql from 'graphql-tag';
import './styles.css';

const SAVE_GAME_MUTATION = gql`
	mutation($gameID: ID!, $data: JSON!) {
		updateGame(gameID: $gameID, data: $data) {
			id
			data
		}
	}
`;

class ResultsDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentCashDecisions: ''
		};
	}
	render() {
		const {
			history,
			game,
			game: {
				cashDecisionsSaved,
				cashDecisions,
				results: {
					revenues,
					operatingIncome,
					cccSales,
					cash,
					leverage,
					roe,
					roa
				}
			}
		} = this.props;
		const { currentCashDecisions } = this.state;
		const data = [
			{ label: 'Revenues', values: revenues },
			{ label: 'Operating Income (EBIT)', values: operatingIncome },
			{ label: 'CCC/Sales', values: cccSales },
			{
				label: 'Cash',
				values: cash
			},
			{
				label: 'Leverage',
				values: leverage
			},
			{
				label: 'ROE',
				values: roe
			},
			{
				label: 'ROA',
				values: roa
			}
		];
		const options = {
			textStyle: {
				color: 'black'
			},
			grid: {
				width: '85%',
				left: '15%'
			},
			legend: {
				type: 'scroll',
				orient: 'horizontal',
				top: '10',
				left: '0',
				data: data.map(row => row.label),
				textStyle: {
					color: '#3a3a40'
				}
			}
		};
		return (
			<div className="results-document">
				<ResultsDocumentLayout>
					<ResultsDocumentLayout.Header>
						<span>results.doc</span>
						<span
							onClick={() => {
								history.goBack();
							}}
						>
							CLOSE
						</span>
					</ResultsDocumentLayout.Header>
					<ResultsDocumentLayout.Body>
						<ResultsDocumentLayout.BodyHeader>
							<div>
								<Icon icon="businessplanEris" />
								<span>Business Plan</span>
							</div>
						</ResultsDocumentLayout.BodyHeader>
						<ResultsDocumentLayout.BodyContent>
							<h4>Congratulations!</h4>
							<FormattedHTMLMessage id="results-document-text1" />
							<div>
								<div>
									<Icon icon={'heart'} />
									You have kept <b>{game.hearts} lives</b>
								</div>
								<div>
									<Icon icon={'money'} />
									You have earned a compensation of{' '}
									<b>{numeral(game.money).format('0,0')} €</b>
								</div>
							</div>
							<FormattedHTMLMessage id="results-document-text2" />
							<EconomicChart options={options} data={data} />
							<FormattedHTMLMessage id="results-document-text3" />
							<TextArea
								value={
									cashDecisionsSaved ? cashDecisions : currentCashDecisions
								}
								placeholder={'Write your report…'}
								disabled={cashDecisionsSaved}
								onChange={e => {
									this.setState({ currentCashDecisions: e.target.value });
								}}
							/>
							<FormattedHTMLMessage id="results-document-text4" />
							<div>
								<Icon className="sign" icon={'sign'} />
							</div>
							<div>
								<ResultsDocumentLayout.GreyButton game={game} />
								<Mutation mutation={SAVE_GAME_MUTATION}>
									{(saveGame, data) => (
										<SetCashDecision>
											{setCashDecision => (
												<ResultsDocumentLayout.OrangeButton
													disabled={cashDecisionsSaved}
													onClick={() =>
														!cashDecisionsSaved &&
														setCashDecision({
															variables: {
																gameID: game.id,
																value: currentCashDecisions
															}
														}).then(() => {
															this.saveGame(saveGame, game, data);
														})
													}
												/>
											)}
										</SetCashDecision>
									)}
								</Mutation>
							</div>
						</ResultsDocumentLayout.BodyContent>
					</ResultsDocumentLayout.Body>
					<ResultsDocumentLayout.Footer>
					</ResultsDocumentLayout.Footer>
				</ResultsDocumentLayout>
			</div>
		);
	}
	saveGame(mutate, game, data) {
		const fragment = gql`
			fragment gameFragment on Game {
				id
				data
			}
		`;
		const newGame = data.client.cache.readFragment({
			fragment,
			id: `Game:${game.id}`
		});
		const gameData = cloneDeep(newGame.data);
		gameData.test = gameData.test + 1 || 0;
		mutate({
			variables: {
				gameID: game.id,
				data: gameData
			}
		});
	}
}
ResultsDocument.propTypes = {
	history: PropTypes.object,
	game: PropTypes.shape({
		money: PropTypes.number,
		hearts: PropTypes.number,
		results: PropTypes.shape({
			revenues: MultiYearScalarType,
			operatingIncome: MultiYearScalarType,
			cccSales: MultiYearScalarType,
			cash: MultiYearScalarType,
			leverage: MultiYearScalarType,
			roe: MultiYearScalarType,
			roa: MultiYearScalarType
		})
	})
};

export default ResultsDocument;
